import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { mostrarCarterasSinoEsta } from '../../redux/reducers/carterasReducers';
import {FormControl, InputLabel} from "@mui/material";
import {SelectSmart} from "../CustomTextField";
import Strings from "../../assets/strings";
import {hasPermissionTo, PERSMISOS, PERSMISOS_USUARIOS} from "../../helpers";
import {useAppDispatch, useAppSelector} from "../../redux/hooks";

type IProps = {
    required?: boolean
    disabled?: boolean
    margin?: "none" | "dense" | "normal" | undefined
    value?: number
    name?: string
    label?: string
    all?: boolean
    onChange?: any
}

export default function SelectCartera({ value , name = "carteraId",label=Strings.carteras, onChange, all}:IProps) {

    const dispatch = useAppDispatch();
    const carteras = useAppSelector(state => state.carteras);


    useEffect(() => {
        if(hasPermissionTo(PERSMISOS.carteras) && hasPermissionTo(PERSMISOS_USUARIOS.carteras)){
            dispatch(mostrarCarterasSinoEsta());
        }
    }, [dispatch]);


    let options = (carteras.list?.map(opc=>({key:opc.id,value:opc.descripcion}))) || [];
    options.unshift({key:undefined,value:all?Strings.todo:Strings.seleccione})

    return (

        <FormControl fullWidth>
            <InputLabel shrink>{label}</InputLabel>
            <SelectSmart
                value={value??""}
                onChange={onChange}
                name={name}
                loading={carteras.status === "loading" }
                opciones={options}
            />
        </FormControl>

    );
}
